import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BillingDocument, STATUS_LABEL, TYPE_LABEL, billingApi, euro } from '@/services/billingApi';

export function BillingPracticePanel({ practiceId, clientId }: { practiceId: string; clientId: string }) {
  const [docs, setDocs] = useState<BillingDocument[]>([]);
  useEffect(() => {
    billingApi.practiceDocs(practiceId).then(setDocs).catch(() => setDocs([]));
  }, [practiceId]);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-sm font-medium text-gray-700">Preventivi e conti</CardTitle>
        <div className="flex gap-2">
          <Link to={`/preventivi-e-conti/nuovo?type=QUOTE&clientId=${clientId}&practiceId=${practiceId}`}>
            <Button size="sm" variant="outline">Preventivo</Button>
          </Link>
          <Link to={`/preventivi-e-conti/nuovo?type=INVOICE&clientId=${clientId}&practiceId=${practiceId}`}>
            <Button size="sm" variant="outline">Fattura</Button>
          </Link>
        </div>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        {docs.length === 0 && <div className="text-gray-500">Nessun documento collegato</div>}
        {docs.map((d) => (
          <div key={d.id} className="flex justify-between">
            <Link className="text-blue-600" to={`/preventivi-e-conti/${d.id}`}>
              {TYPE_LABEL[d.type]} {d.numberDisplay || 'bozza'}
            </Link>
            <span>{STATUS_LABEL[d.status]} · {euro(d.total)}</span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
